module.exports = __webpack_public_path__ + "static/media/trademark.81b74935.svg";